module.exports = __webpack_public_path__ + "03_mole.6f005620.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer2/03_mole.png
// module id = h0lT
// module chunks = 0